import { IWizardCol } from '../../wizard/wizard-col.component';
import { WizardService } from '../../wizard/wizard.service';

export const step2 = {
    eva: {
      title: 'sessions.create.wizard.step2.title',
      subscription: new WizardService().getSessionTypeSubscription(),
      cols: [
        {
          title: 'sessions.create.wizard.step2.video',
          description: ['sessions.create.wizard.step2.video_description'],
          icon: 'video-camera',
          option: 'video',
          info: 'sessions.create.wizard.step2.video_info'
        },
        {
          title: 'sessions.create.wizard.step2.interactive',
          description: ['sessions.create.wizard.step2.interactive_description'],
          icon: 'pencil-square',
          option: 'interactive',
          info: 'sessions.create.wizard.step2.interactive_info'
        },
        {
          title: 'sessions.create.wizard.step2.360',
          description: ['sessions.create.wizard.step2.360_description'],
          icon: 'repeat',
          option: 'mixte',
          info: 'sessions.create.wizard.step2.360_info'
        }
      ]
    },
    mylivetv: {
      isFirst: true,
      title: 'sessions.create.wizard.step2.title_won',
      subscription: new WizardService().getSessionTypeSubscription(),
      cols: [
        {
          title: 'sessions.create.wizard.step2.video',
          description: ['sessions.create.wizard.step2.video_description'],
          icon: 'video-camera',
          option: 'video',
          info: 'sessions.create.wizard.step2.video_info'
        },
        
        {
          title: 'sessions.create.wizard.step2.vod',
          description: ['sessions.create.wizard.step2.vod_description'],
          icon: 'repeat',
          option: 'vod',
          info: 'sessions.create.wizard.step2.vod_info'
        }
      ]
    }
};



// WEBPACK FOOTER //
// ./src/app/modules/sessions/create/step/step2.ts